document.addEventListener( 'wpcf7mailsent', function( event ) {
	var baseUrl = window.location.origin;
    location = baseUrl + '/thank-you/';
}, false );